import React, { Component } from 'react'
import { gql, graphql } from 'react-apollo'
import t from 'prop-types'
import {
  Button,
  Grid,
  Notifications,
  Modal,
  Form,
  Loading,
} from 'components/UI'


class FloorFilter extends Component {
  constructor(props) {
    super(props)
    this.state = {
      selection: props.selection,
    }
  }

  handleClose = () => this.props.onClose()
  
  handleFormChange = items => {
    this.setState({
      selection: items,
    })
  }

  handleApply = () => {
    this.props.onSubmit(this.state.selection)
    this.handleClose()
  }

  handleClear = () => {
    this.props.onSubmit([])
    this.handleClose()
  }

  render () {
    const {
      error,
      loading,
      building,
    } = this.props.data

    if (error) return <Notifications.Error message={error.message} />

    const items = loading ? [] : building.floors.map(floor => ({
      id: floor.id,
      label: floor.name,
    }))
  
    return (
      <Modal
        onBlur={this.handleClose}
        width={500}
        open
      >
        <Grid.Row>
          <h3>SELECT THE FLOORS YOU WANT DISPLAYED</h3>
        </Grid.Row>
        <Grid.Row>
          { loading ? <Loading /> :
            <Form.CheckboxList
              onChange={this.handleFormChange}
              items={items}
              selection={this.state.selection}
            />
          }
        </Grid.Row>
        <Grid.Row>
          <Button onClick={this.handleApply}>Apply</Button>
          <Button onClick={this.handleClear}>Show All</Button>
          <Button onClick={this.handleClose}>Cancel</Button>
        </Grid.Row>
      </Modal>
    )
  }
}

FloorFilter.propTypes = {
  items: t.array.isRequired,
  onSubmit: t.func.isRequired,
  onClose: t.func.isRequired,
  selection: t.array.isRequired,
  buildingId: t.string.isRequired,
}

FloorFilter.defaultProps = {
  selection: [],
  items: [],
}

const FloorFilterQuery = gql`
  query FloorFilterQuery($id: Int!) {
    building(id: $id) {
      floors {
        id
        name
      }
    }
  }
`

export default graphql(FloorFilterQuery, {
  options: ({ buildingId }) => ({
    variables: {
      id: parseInt(buildingId, 10)
    },
    notifyOnNetworkStatusChange: true,
  }),
})(FloorFilter)



// WEBPACK FOOTER //
// ./src/components/Unit/FloorFilter.jsx